import React from "react";
import { Avatar, Checkbox } from "antd";
import { ChatItem } from "../../types/chat";
import styles from "./ShareMessageModal.module.scss";

interface ChatRoomItemProps {
  chat: ChatItem;
  isSelected: boolean;
  onToggle: () => void;
}

const ChatRoomItem: React.FC<ChatRoomItemProps> = ({ chat, isSelected, onToggle }) => {
  return (
    <div className={styles.chatItem} onClick={onToggle}>
      <div className={styles.chatItemContent}>
        <Avatar src={chat.AvatarUrl} size={40}>
          {!chat.AvatarUrl && chat.RoomName?.charAt(0).toUpperCase()}
        </Avatar>
        <div className={styles.chatInfo}>
          <div className={styles.chatName}>{chat.RoomName}</div>
          {chat.LastMessage && <div className={styles.lastMessage}>{chat.LastMessage}</div>}
        </div>
      </div>
      <Checkbox checked={isSelected} onClick={(e) => e.stopPropagation()} onChange={onToggle} />
    </div>
  );
};

export default ChatRoomItem;
